import { assign } from 'xstate';
export function clearContextAction({ initialContext }) {
    return assign((_ctx) => initialContext);
}
